export const gaTrackingId = 'UA-155867204-1'
